var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 6,
    fill: "none",
    viewBox: "0 0 11 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M.348.416A.875.875 0 0 1 1.584.348l3.88 3.477L9.343.348a.875.875 0 1 1 1.168 1.304l-4.464 4a.875.875 0 0 1-1.167 0l-4.464-4A.875.875 0 0 1 .348.416",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;